import { PipelineClientWrapper } from './PipelineClientWrapper';

export default function PipelinePage() {
    return (
        <div>
            <PipelineClientWrapper
                initialData={[]}
                pagination={undefined}
            />
        </div>
    );
}